import type { RootState } from '@/shared/store'
import { slidesAdapter } from './slideAdapter'

const slidesSelectors = slidesAdapter.getSelectors(
  (state: RootState) => state.editor.slides,
)

export const selectAllSlides = slidesSelectors.selectAll
export const selectSlideById = slidesSelectors.selectById
export const selectSlideIds = slidesSelectors.selectIds
